module.exports = __webpack_public_path__ + "static/media/download.71f6ad8b.svg";